import React, { useContext } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { NavLink } from 'react-router'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { observer } from 'mobx-react'

const RightsholderSubNavigationMobile = () => {
    const { rightsholderStore, rightsholderUserStore } = useContext(StoresContext)
    const currentRightsHoldersId = rightsholderStore.currentRightsholderId
    const memberSummary = rightsholderStore.memberSummary

    const hasManageContactPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address
    )
    const hasManageBankingPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax
    )

    return (
        <div className="rightsholder-sub-navigation-mobile">
            <div className="mobile-menu-head">
                <img src={ICONS.account} alt="Accounts" />
                <h4 title={memberSummary.name} className="text-white">
                    {memberSummary.name}
                </h4>
            </div>
            <div className="tabs">
                <NavLink
                    to={Navigation.rightholder.summary(currentRightsHoldersId)}
                    className={({ isActive }) => clsx('small-2 bold', isActive && 'tab-active')}
                >
                    Summary
                </NavLink>
                <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                    <NavLink
                        to={Navigation.rightholder.catalog.root(currentRightsHoldersId)}
                        className={({ isActive }) => clsx('small-2 bold', isActive && 'tab-active')}
                    >
                        Catalog
                    </NavLink>
                </PermissionCheck>
                {(hasManageContactPermission || hasManageBankingPermission) && (
                    <NavLink
                        to={Navigation.rightholder.maintenance.root(currentRightsHoldersId)}
                        className={({ isActive }) => clsx('small-2 bold', isActive && 'tab-active')}
                    >
                        Member Settings
                    </NavLink>
                )}
            </div>
        </div>
    )
}

export default observer(RightsholderSubNavigationMobile)
